// The move off ServiceTitan, said on every screen while it's under way (BL-103): a slim line across
// the top of the office app for the owner and the managers, from the owner's written OK until the
// company goes live, with Open to the migration place. Read once a page load, again after two
// minutes, and at once when the run is changed on this page (QA-876); nothing is read for anyone
// else, and before the OK only the checklist is.

import { useEffect, useState } from 'react';
import { client } from '../api.ts';
import { BANNER_PERMS, holds, MIGRATION_CHANGED, migrationLine, type Status, type Step } from './model.ts';

// kept by company, so another company signed in on this page never reads the last one's line
let loaded: { tenant: string; at: number; line: Promise<string | null> } | null = null;
function line(tenant: string): Promise<string | null> {
  if (!loaded || loaded.tenant !== tenant || Date.now() - loaded.at > 120_000)
    loaded = {
      tenant,
      at: Date.now(),
      line: client
        .call<{ steps: Step[] }>('migration.cutoverChecklist', {})
        .then(async (c) => {
          const authorised = c.steps.find((s) => s.key === 'authorised')?.done ?? false;
          if (!authorised) return null;
          return migrationLine(true, await client.call<Status>('migration.status', {}));
        })
        .catch(() => null),
    };
  return loaded.line;
}

export function MigrationBanner({
  tenant,
  held,
  here,
}: {
  tenant: string;
  held: readonly string[];
  here: boolean;
}) {
  const shown = holds(held, BANNER_PERMS);
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    if (!shown) return;
    let live = true;
    const read = () => void line(tenant).then((t) => live && setText(t));
    read();
    const changed = () => {
      loaded = null;
      read();
    };
    window.addEventListener(MIGRATION_CHANGED, changed);
    return () => {
      live = false;
      window.removeEventListener(MIGRATION_CHANGED, changed);
    };
  }, [shown, tenant]);
  if (!shown || !text) return null;
  return (
    <div className="mig-banner" role="status">
      <p title={text}>{text}</p>
      {/* on the migration place itself there's nowhere to go */}
      {!here && (
        <a className="btn small soft" href="#/migration">
          Open
        </a>
      )}
    </div>
  );
}
